/* eslint-disable */
// @ts-nocheck
import { DefaultLoadingManager } from "three";
import { GLTFLoader } from "./GLTFLoader";
import { DRACOLoader } from "./DRACOLoader";
export function buildDracoLoader() {
  // @ts-ignore
  const dracoLoader = new DRACOLoader(DefaultLoadingManager);
  dracoLoader.setDecoderPath("https://vortex.documents.cimpress.io/draco/v3/");
  dracoLoader.setDecoderConfig({
    type: "js"
  });
  return dracoLoader;
}
export function buildGLTFLoader(dracoLoader) {
  // @ts-ignore
  const loader = new GLTFLoader(DefaultLoadingManager);
  loader.setDRACOLoader(dracoLoader);
  return loader;
}